import brandLogo from 'assets/logo.png'

const authBrandLogo = () => {
  return brandLogo
}

export default authBrandLogo
